module.exports = __webpack_public_path__ + "img/product-landerlab-img.d6df027f.jpg";